// extracted by mini-css-extract-plugin
export default {"ns_panel":"NSPanel_ns_panel__3YeX6"};